import config from '../../infra/config';

const HOST = config.AUDIENCE_PROFILER_API;
const HEADERS = { 'wait-for-completion': 'false' };

export default {
  getSegmentIds: (audience) => ({
    url: `${HOST}/api/1/get-segment-ids`,
    headers: { ...HEADERS },
    payload: { ...audience },
  }),
  getRawDemographicsDataByLogicalStatement: (payload, params) => ({
    method: 'post',
    params,
    payload,
    headers: { ...HEADERS },
    url: `${HOST}/api/v2/audience/demographics`,
  }),
  getRawInsightsData: (payload, searchType) => ({
    method: 'post',
    payload,
    headers: { ...HEADERS },
    url: `${HOST}/api/v2/audience/insights/${searchType}`,
  }),
  getRawInterestsDataV2: (payload, searchType, uriSuffix) => ({
    method: 'post',
    payload,
    headers: { ...HEADERS },
    url: `${HOST}/api/v2/audience/interests/${searchType}${uriSuffix}`,
  }),
};
